<template>
  <div>
    <!-- <div v-if="this.validCU.enroll === 'E'"> -->
    <div>
      <div :style="{ fontSize: fonts.font22 + 'px' }" class="pageHeader">
        Sign Up for Home Bank<br />access on account {{siFormUser}}
      </div>
      <div id="verifyBox">
        <div :style="{ fontSize: fonts.font20 + 'px'}" class="veriTitle">
        Please verify the following information.
        </div>
        <div style="height: 5px;"></div>
        <div>
          <span>Primary Birth date:
            <div class="ssmall">(enter date mm/dd/yyyy or select on calendar)</div>
          </span>
          <div id="dobContainer">
            <el-date-picker
              id="dobCalendar"
              class="inputField"
              v-model="dob"
              format="MM/dd/yyyy"
              value-format="MM/dd/yyyy"
              type="date"
              :editable="false"
              :clearable="false"
              size="mini"
              placeholder="Primary Birth Date">
            </el-date-picker>
            <b-form-input
              :name="dob2Rand"
              id="dobText"
              ref="inpDob"
              autocomplete="nope"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              class="inputField"
              aria-label="Primary Birth Date"
              type="text"
              v-model="dob"
              placeholder="Primary Birth Date">
            </b-form-input>
            <div id="dobCM" class="checkmark_container" v-bind:class="{ show_checkmark: dobValid }">
              <svg width="50%" height="50%" viewBox="0 0 140 100">
                <path class="checkmark"
                      v-bind:class="{ checked: dobValid }"
                      d="M10,50 l25,40 l95,-70" />
              </svg>
            </div>
          </div>
        </div>
        <div>
          <span>5-digit Zip Code on Account:</span>
          <div id="zipContainer">
            <b-form-input :name="zipRand"
                          ref="zip"
                          autocomplete="nope"
                          autocorrect="off"
                          autocapitalize="off"
                          spellcheck="false"
                          class="inputField"
                          aria-label="Five digit Zip Code"
                          type="text"
                          v-model="zip"
                          required
                          placeholder="Five digit Zip Code">
            </b-form-input>
            <div id="zipCM" class="checkmark_container" v-bind:class="{ show_checkmark: zipValid }">
              <svg width="50%" height="50%" viewBox="0 0 140 100">
                <path class="checkmark"
                      v-bind:class="{ checked: zipValid }"
                      d="M10,50 l25,40 l95,-70" />
              </svg>
            </div>
          </div>
        </div>
        <div>
          <span>Last 4 digits of Primary SSNo:</span>
          <div id="ssnContainer">
            <b-form-input :name="ssnRand"
                          ref="ssn"
                          autocomplete="nope"
                          autocorrect="off"
                          autocapitalize="off"
                          spellcheck="false"
                          class="inputField"
                          aria-label="Last 4 digits of SSNo"
                          type="text"
                          v-model="ssn"
                          required
                          placeholder="Last 4 digits of SSNo">
            </b-form-input>
            <div id="ssnCM" class="checkmark_container" v-bind:class="{ show_checkmark: ssnValid }">
              <svg width="50%" height="50%" viewBox="0 0 140 100">
                <path class="checkmark"
                      v-bind:class="{ checked: ssnValid }"
                      d="M10,50 l25,40 l95,-70" />
              </svg>
            </div>
          </div>
        </div>
        <div style="height: 5px;"></div>
      </div>
      <div id="enrollBox">
        <div :style="{ fontSize: fonts.font20 + 'px'}" class="veriTitle">
          Enrollment information.
        </div>
        <div style="height: 5px;"></div>
        <div>
          <span>New Password for Account</span>
          <!-- <div>{{newPassword}} ({{myPwValid}})</div> -->
          <zPass ref="pw1"></zPass>
        </div>
      </div>
      <div style="height: 10px;"></div>
      <div>
        <span>New Email Address for Account</span>
        <div id="emailContainer">
          <b-form-input :name="emaRand"
                        ref="ema"
                        id="emailAddress"
                        autocomplete="nope"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        class="inputField"
                        aria-label="New Email Address"
                        type="text"
                        v-model="eAddr"
                        required
                        placeholder="New Email Address">
          </b-form-input>
          <div id="emailCM" class="checkmark_container"
               v-bind:class="{ show_checkmark: emailValid }">
            <svg width="50%" height="50%" viewBox="0 0 140 100">
              <path class="checkmark"
                    v-bind:class="{ checked: emailValid }"
                    d="M10,50 l25,40 l95,-70" />
            </svg>
          </div>
        </div>
      </div>
      <div style="height: 10px;"></div>
      <div class="finePrint">
        <b-form-checkbox
          class="agree"
          name="ckEstate"
          ref="ckEstate"
          v-model="eState"
        >I agree to Electronic Statements Only
        </b-form-checkbox>
        <span class="noPaper">(You will NOT receive a paper copy in the mail)</span>
      </div>
      <div style="height: 20px;"></div>
      <div v-if="this.validCU.enroll === 'E'" class="finePrint">
        <div id="agreeContainer">
          <b-form-checkbox
            name="ckAgree"
            ref="ckAgree"
            class="disclosureCheck"
            v-model="agree">I have read and agree to
          </b-form-checkbox>
          <div id="agreeCM" class="checkmark_container"
               v-bind:class="{ show_checkmark: agree }">
            <svg width="50%" height="50%" viewBox="0 0 140 100">
              <path class="checkmark"
                    v-bind:class="{ checked: agree }"
                    d="M10,50 l25,40 l95,-70" />
            </svg>
          </div>
        </div>
        <span id="disclosure" @click="showDisclosure"> this disclosure</span>
      </div>
      <div style="height: 30px;"></div>
      <b-button-group>
        <b-button :class="{disabled: !enableEnrollButton}"
                  id="btnEn"
                  name="btnEnroll"
                  ref="btnEnroll"
                  @click="enroll">
          Enroll
        </b-button>
        <b-button class="btnCan"
                  name="btnCancel"
                  ref="btnCancel"
                  @click="cancel">
                  Cancel
        </b-button>
        <b-button id="btnHelp"
                  name="btnHelp"
                  ref="btnHelp"
                  @click="help">
          Help
        </b-button>
      </b-button-group>
      <div style="height: 5px;"></div>
    </div>
    <!-- <div v-if="this.validCU.enroll !== 'E'">
      <div style="height: 5px;"></div>
      <div class="noEnroll" :style="{ fontSize: fonts.font14 + 'px' }" >
        Member initiated Home Bank enrollment is not enabled.<br />
        Your Credit Union will need to enroll this account.<br />
        Please contact them during normal business hours.
      </div>
      <div style="height: 5px;"></div>
      <b-button class="btnExit"
                name="exitEnroll"
                @click="cancel">
        OK
      </b-button>
      <div style="height: 5px;"></div>
    </div> -->
  </div>
</template>

<script>
import zPass from './z-pass';
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  components: {
    zPass,
  },
  name: 'enroll',
  data() {
    return {
      passStyle: '',
      dob: '',
      zip: '',
      ssn: '',
      eAddr: '',
      dobRand: '',
      dob2Rand: '',
      zipRand: '',
      ssnRand: '',
      emaRand: '',
      eState: true,
      agree: false,
      myPwValid: '',
      gotAlert: false,
    };
  },
  watch: {
    myTenth() {
      this.intervalTenthSecond();
    },
    doSsnFocus() {
      if (this.doSsnFocus === true) {
        this.$store.commit('setDoSsnFocus', false);
        this.$refs.ssn.$el.focus(); // Set Focus on element with ref="ssn"
      }
    },
    pwValid() {
      if (this.pwValid === true) {
        this.myPwValid = 'true';
      } else {
        this.myPwValid = 'false';
      }
    },
    dob() {
      utl.diag(`dob changed: ${this.dob}`);
    },
  },
  computed: {
    validCU() {
      return this.$store.getters.getValidCU;
    },
    pw1Rand() {
      return this.$store.getters.getPw1Rand;
    },
    pw2Rand() {
      return this.$store.getters.getPw2Rand;
    },
    newPassword() {
      return this.$store.getters.getNewPassword;
    },
    pwValid() {
      return this.$store.getters.getPwValid;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    siFormUser() {
      return this.$store.getters.getSiFormUser;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
    myTenth() {
      return this.$store.getters.getMyTenth;
    },
    doSsnFocus() {
      return this.$store.getters.getDoSsnFocus;
    },
    dobValid() {
      let result = true;
      if (this.dob == null) {
        result = false;
      } else {
        // eslint-disable-next-line
        if (this.dob.length < 10) {
          result = false;
        } else {
          utl.diag(`before: ${this.dob}`);
          const myDob = utl.pakStrDate(this.dob); // [130] was pakDate()
          if (myDob < 1) { result = false; }
          if (myDob > 65379) { result = false; } // 12/31/2078 Max date
          utl.diag(`after: ${this.dob}`);
          utl.diag(`packed: ${myDob}`);
        }
      }
      return result;
    },
    zipValid() {
      return (this.zip.length === 5);
    },
    ssnValid() {
      return (this.ssn.length === 4);
    },
    emailValid() {
      let result = true;
      const myAt = this.eAddr.indexOf('@');
      const myDot = this.eAddr.indexOf('.', myAt); // [141] added ,myAt
      if (myAt < 1) { result = false; }
      if (myDot < myAt) { result = false; }
      if (myDot === myAt + 1) { result = false; }
      if (this.eAddr.length === myDot + 1) { result = false; } // At least one char after .
      return result;
    },
    enableEnrollButton() {
      let result = true;
      if (this.dobValid === false) { result = false; }
      if (this.zipValid === false) { result = false; }
      if (this.ssnValid === false) { result = false; }
      if (this.pwValid !== true) { result = false; }
      if (this.emailValid === false) { result = false; }
      if (this.validCU.enroll === 'E') {
        if (this.agree !== true) { result = false; }
      }
      if (this.gotAlert === true) {
        if (result === true) this.hideAlert();
      }
      return result;
    },
  },
  methods: {
    enroll() {
      if (this.enableEnrollButton) {
        const info = {};
        info.cun = this.cun;
        info.acct = this.siFormUser; // [0103] was this.member.acct, which was wrong
        info.dob = utl.pakStrDate(this.dob); // [130] was pakDate()
        info.zip = this.zip;
        info.ssn = this.ssn;
        info.newPW = this.newPassword;
        info.eAddr = this.eAddr;
        info.eState = this.eState;
        info.agree = this.agree;
        utl.diag(`dob: ${this.dob}`);
        utl.diag(info);
        this.wsSend('c4RequestEnrollment', info);
        // this.showConfirm('Sending request to server...');
      } else {
        if (this.dobValid === false) {
          this.showAlert('Invalid entry for Date Of Birth');
          return;
        }
        if (this.zipValid === false) {
          this.showAlert('Zip code must be exactly FIVE digits long');
          return;
        }
        if (this.ssnValid === false) {
          this.showAlert('Last 4 of Social Security Number must be exactly FOUR digits long');
          return;
        }
        if (this.pwValid === false) {
          this.showAlert('You have not met security restrictions for the new Password');
          return;
        }
        if (this.emailValid === false) {
          this.showAlert('Please enter a valid Email Address');
          return;
        }
        if (this.agree !== true) {
          this.showAlert('You must indicate you have read and agree to the Disclosure');
          return;
        }
        this.showAlert('Please complete all information above');
      }
    },
    cancel() {
      window.history.back();
    },
    help() {
      //
    },
    hideAlert() {
      this.gotAlert = false;
      this.$store.commit('setAlertShow', false);
    },
    showAlert(message) {
      this.gotAlert = true;
      this.$store.commit('setAlertMessage', message);
    },
    intervalTenthSecond() {

    },
    showDisclosure() {
      this.$store.commit('getDisclosure');
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
    showConfirm(message) {
      this.$store.commit('setConfirmMessage', message);
    },
    handleKeyStroke(event) {
      let handled = false;
      let keyCode = event.keyCode;
      const e1 = document.activeElement;
      // utl.diag(`enroll-keyPressed: ${event.keyCode}`);
      // utl.diag('Focused Element:');
      // utl.diag(e1);
      if (keyCode === 13) { // Enter Pressed
        // utl.diag('Enter Pressed');
        // utl.diag(`e1.name="${e1.name}"`);
        keyCode = 0;
        if ((e1.name === this.dob2Rand) && (this.dobValid === true)) {
          this.$refs.zip.focus(); handled = true;
        }
        if ((e1.name === this.zipRand) && (this.zipValid === true)) {
          this.$refs.ssn.focus(); handled = true;
        }
        if ((e1.name === this.ssnRand) && (this.ssnValid === true)) {
          this.$store.commit('setFocusChangePW', true);
          handled = true;
        }
        if ((e1.name === this.pw1Rand) && (this.pwValid === true)) {
          this.$refs.ema.focus(); handled = true;
        }
        if ((e1.name === this.emaRand) && (this.emailValid === true)) {
          this.$refs.ckEstate.focus(); handled = true;
        }
        if (e1.name === 'ckEstate') {
          this.$refs.ckAgree.focus(); handled = true;
        }
        if ((e1.name === 'ckAgree') && (this.agree === true)) {
          // this.$refs.btnEnroll.focus(); handled = true;
          this.enroll();
        }
        // if (e1.name === 'btnEnroll') { this.$refs.btnCancel.focus(); handled = true; }
        // if (e1.name === 'btnCancel') { this.$refs.btnHelp.focus(); handled = true; }
        // if (e1.name === 'btnHelp') { this.$refs.inpDob.focus(); handled = true; }
        if (handled === true) {
          event.preventDefault();
          event.stopPropagation(true);
        }
      }
      //
      if (e1.name === this.dob2Rand) {
        if ((keyCode > 0) && ((keyCode < 48) || (keyCode > 57))) {
          const tgt = event.target;
          event.preventDefault(true);
          event.stopPropagation(true);
          tgt.value += '/'; // Ignore the keyCode and append '/' directly
        }
      }
    },
  },
  mounted() {
    utl.diag('enroll-mounted()');
    utl.diag(this.validCU);
    this.$store.commit('setExtendedPwStatus', true); // New Enroll always extended PW
    const myDate = +new Date();
    this.dobRand = `dob${myDate}`;
    this.dob2Rand = `dob2${myDate}`;
    this.zipRand = `zip${myDate}`;
    this.ssnRand = `ssn${myDate}`;
    this.emaRand = `ema${myDate}`;
    this.$store.commit('setPw1Rand', `pw1${myDate}`); // pw1Rand
    this.$store.commit('setPw2Rand', `pw2${myDate}`); // pw2Rand
    try {
      this.$refs.inpDob.focus(); // Set Focus on element with ref="inpDob"
    } catch (e) {
      // eslint-disable-next-line
      const x = e; // Ignore this
    }
  },
  created() {
    window.addEventListener('keypress', this.handleKeyStroke);
  },
  destroyed() {
    window.removeEventListener('keypress', this.handleKeyStroke);
  },
};

</script>

<style scoped>
  .noEnroll {
    padding: 8px;
    background-color: white;
    color: red;
    font-weight: bold;
  }
  .pageHeader {
    color: red;
  }
  .veriTitle {
    color: blue;
  }
  .inputField {
    position: relative;
    display: flex;
    width: 200px;
    border: solid 1px lime;
    margin: auto;
  }
  #verifyBox {
    position: relative;
    border: solid 1px blue;
  }
  .ssmall {
    font-size: 12px;
    margin-bottom: 4px;
  }
  #btnEn {
    background-color: lime;
    color: black;
    font-weight: bold;
    left: -15px;
  }
  .btnCan {
    background-color: red;
    color: black;
    font-weight: bold;
    left: -5px;
    right: -5px;
  }
  .btnExit {
    background-color: lime;
    color: black;
    font-weight: bold;
  }
  #btnHelp {
    background-color: cyan;
    color: black;
    font-weight: bold;
    right: -5px;
  }
  #emailAddress {
    width: 300px;
  }
  .finePrint {
    font-size: 14px;
  }
  .agree {
    font-weight: bold;
    color: red;
    font-size: 14px;
  }
  .noPaper {
    color: red;
    font-size: 12px;
  }
  .disclosureCheck {
    display: inline;
    color: red;
  }
  #disclosure {
    text-decoration: underline;
    color: blue;
    cursor: pointer;
  }
  #dobContainer {
    position: relative;
    width: 200px;
    margin: auto;
  }
  #dobCalendar {
    position: relative;
  }
  #dobText {
    position: absolute;
    top: 0px;
    left: 30px;
    height: 30px;
    width: 170px;
    padding-left: 8px;
  }
  #dobCM {
    position: absolute;
    top: 0px; right: -50px;
  }
  #zipContainer {
    position: relative;
    width: 200px;
    margin: auto;
  }
  #zipCM {
    position: absolute;
    top: 4px; right: -50px;
  }
  #ssnContainer {
    position: relative;
    width: 200px;
    margin: auto;
  }
  #ssnCM {
    position: absolute;
    top: 4px; right: -50px;
  }
  #emailContainer {
    position: relative;
    width: 300px;
    margin: auto;
  }
  #emailCM {
    position: absolute;
    top: -20px; right: -2px;
  }
  #agreeContainer {
    position: relative;
    width: 200px;
    margin: auto;
  }
  #agreeCM {
    position: absolute;
    top: 4px; right: -50px;
  }

  .checkmark_container {
    border-radius: 50%;
    background: #2ecc71;
    width: 30px; height: 30px;
    visibility: hidden;
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .4s ease;
  }
  .checkmark {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: white;
    stroke-width: 15;
    stroke-linecap: round;
    stroke-dasharray: 180;
    stroke-dashoffset: 180;
  }
  .show_checkmark {
    visibility: visible;
    opacity: 1;
  }
  .checked { animation: draw 0.5s ease forwards; }

  @keyframes draw {
    to { stroke-dashoffset: 0; }
  }

</style>



// WEBPACK FOOTER //
// src/components/enroll.vue